import React from "react";
import * as s from "./index.module.scss";

const spacing = 15;
const speedFactor = 5;

const BrandWeBuy = ({ data, text = "", title }) => {
  const imageWidth = 424;
  const imageHeight = 172;

  const height = imageHeight / 2;
  const width = imageWidth / 2;

  const getImages = (images) => {
    const finalImageArray = [];
    const minimumImageCount = 1920 / width;
    const factor = Math.ceil(minimumImageCount / images?.length);

    for (let i = 0; i < factor; i++) {
      finalImageArray.push(...images);
    }
    return finalImageArray;
  };

  const imageList = getImages(data?.logo);

  return (
    <section className={`section-center ${s.brand_we_buy}`}>
      <div className={s.header}>
        <h3 className="heading fw-bold">{data?.title || title}</h3>
        {text && <p>{text}</p>}
      </div>
      <div className={s.brands}>
        <div
          className={"d-flex z-0 mt-5 animate-scroll"}
          style={{
            animationDuration: `${imageList?.length * speedFactor}s`,
            width: (width + spacing) * imageList?.length,
          }}
        >
          {[...imageList, ...imageList]?.map(({ image }, idx) => {
            return (
              <div
                className={s.logo_swiper}
                key={idx}
                style={{
                  margin: `0 ${spacing / 2}px`,
                  minWidth: width,
                  width,
                  height,
                }}
              >
                <img src={image.url} alt={image?.alt || ""} loading={"lazy"} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BrandWeBuy;
